import axios from 'axios';
import { APP_SETTINGS } from '../../config';

export function getAllPaymentMethods() {
    return axios.get(APP_SETTINGS.API_PATH.PAYMENTMETHOD.getAllPaymentMethods);
}
export function addNewPaymentMethod(paymentMethodData) {
    return axios.post(APP_SETTINGS.API_PATH.PAYMENTMETHOD.addPaymentMethod, paymentMethodData)
}
export function deletePaymentMethod(paymentMethodId) {
    return axios.post(APP_SETTINGS.API_PATH.PAYMENTMETHOD.deletePaymentMethod, {
        "requestId": paymentMethodId
    })
}